import React, { useState, useEffect } from "react";
import FormFactory from "../../services/Form/Form.js";
import localStorage from "mobx-localstorage";
import { BotonOD } from "../../style/oferta-digital/common";
import { InfoClienteContainer, PrivacidadComponent,} from "../../style/oferta-digital/pyme/pymeForm";
import { toJS } from "mobx";
import { cotizacionProductos } from "../../data/compra-en-linea";
import { ScrollToClass } from "../../services/dom";
import { StepModal } from "../../components/carga-documentos/modal";
import { PymeB, Datos_Protegidos } from "../../style/oferta-digital/pyme/pyv2";
import FAQ from "@components/compra-en-linea/FAQ";
import graphCall from "graphcms/service/graphcms";
import HomePageQuery from "graphcms/queries/homepage";
import PymeForm from "graphcms/queries/pymeForm";
import { refererListData } from "../../data/socios-comerciales-data";
import * as Sentry from "@sentry/react";
import router, { useRouter } from "next/router";

export async function getServerSideProps({ req, res }) {
  const logoAnchor = { anchor: "pyme_form", offset: -140 };
  const current_site = "oferta_digital_cotizacion";
  const current_page = "info_pyme";

  let HpData = await graphCall(HomePageQuery, { title: "QuotePage" });
  let pymeData = await graphCall(PymeForm, { title: "PymeForm" });

  return {
    props: {
      pyme: pymeData.odPymeForm,
      faqs: HpData.odHomePage.faqs,
      logoAnchor: logoAnchor,
      current_page: current_page,
      current_site: current_site,
    },
  };
}

let callHubSpot = async (data, opportunity, referer) => {

  let quoteHash = null;
  debugger;

  let carryObj = {
    firstname: data.nombre,
    lastname: data.apellido,
    email: data.correo,
    phone: '+52' + data.telefonoCompleto,
    razon_social_de_la_empresa: data.razonSocial,
    producto_obd: `${data.tarjetasDespensa ? "Vales de Despensa;" : ""}${data.tarjetasCombustible ? "Vales de Combustible;" : ""
      }${data.tarjetasIncentivos ? "Incentivos para empleados;" : ""}`,
    monto_mensual_incentivos_para_empleados_obd: data.montoIncentivos
      ? data.montoIncentivos.replace(/[^\d.]/g, "")
      : "0",
    monto_mensual_vales_de_despensa_obd: data.montoDespensa
      ? data.montoDespensa.replace(/[^\d.]/g, "")
      : "0",
    monto_mensual_vales_de_combustible_obd: data.montoCombustible
      ? data.montoCombustible.replace(/[^\d.]/g, "")
      : "0",
    numero_de_tarjetas_despensa: data.tarjetasDespensa
      ? data.tarjetasDespensa.replace(/[^\d.]/g, "")
      : "0",
    numero_de_tarjetas_combustible: data.tarjetasCombustible
      ? data.tarjetasCombustible.replace(/[^\d.]/g, "")
      : "0",
    numero_de_tarjetas_incentivos_para_empleados: data.tarjetasIncentivos
      ? data.tarjetasIncentivos.replace(/[^\d.]/g, "")
      : "0",
    id_oportunidad_obd: opportunity ? opportunity.opportunityId : "",
    link_obd: opportunity
      ? `${window.location.origin}/creacion-cuenta?id=${opportunity.opportunityId}&lada=${data.lada}&telefono=${data.telefono}`
      : "",
    inversion_inicial_obd: "0",//cotizacion.inversionInicial.replace(/[^\d.]/g,""),
    inscripcion_obd: "0", //cotizacion.inscripcion.replace(/[^\d.]/g, ""),
    costo_de_envio: "0", //cotizacion.costoEnvio.replace(/[^\d.]/g, ""),
    total_tarjetas_obd: "0", //cotizacion.costoTarjetas.replace(/[^\d.]/g, ""),
    total_tarjetas_despensa: "0",
    total_tarjetas_combustible: "0",
    total_tarjetas_incentivos_obd: "0",
    costo_mensual_despensa: "0",
    costo_mensual_combustible: "0",
    costo_mensual_incentivos_obd: "0",
    costo_por_servicio_de_dispersion_despensa_obd: "0",
    tasa_despensa_obd: "0",
    costo_por_servicio_de_dispersion_combustible: "0",
    tasa_combustible_obd: "0",
    costo_por_servicio_de_dispersion_incentivos_obd: "0",
    tasa_incentivos_obd: "0",
    referencia_obd: referer,
    //url_cotizacion_obd: `${window.location.origin}/micotizacion?quoteHash=${quoteHash}${referer ? `&referer=${referer}` : ""}`,
    //--> Aqui comente 
  };

  await fetch("/api/hubspot/sendForm", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(carryObj),
  })
    .then((res) => {
      console.log(carryObj);
      if (res.ok) {
        console.log('Sent to Hubspot');
      } else {
        Sentry.captureException(Error('api/hubspot/sendForm'), {
          tags: {
            section: "cotizacion - hubspot",
            error: `Hubspot status ${res.status}`,
          },
        });
      }
    })
    .catch((err) => {
      Sentry.captureException(Error('api/hubspot/sendForm'), {
        tags: {
          section: "cotizacion - hubspot",
          error: err.toString(),
        },
      });
    });
}

let callHubSpot2 = async (dataSpecial) => {

  let bodyObj = dataSpecial;
  let fields = [];
  Object.keys(bodyObj).forEach((x) => {
    fields.push({
      name: x,
      value: bodyObj[x],
    });
  });

  let urlActual = window.location.href;
  
  console.log(urlActual);

  if(urlActual.includes('www.sivale.mx/compra-en-linea')){
    process.env.PORTALID_HUBSPOT = '5881411';
    process.env.FORMID_HUBSPOT = 'ac707646-bfbd-47db-8c78-0523ce3759eb';
    //PROD
  }else if(urlActual.includes('web-qa')){
    process.env.PORTALID_HUBSPOT = '45185422';
    process.env.FORMID_HUBSPOT = '8488da1a-81c1-4475-8fbf-946ef6ee4652';
    //SANDBOX
  }else{
    process.env.PORTALID_HUBSPOT = '45185422';
    process.env.FORMID_HUBSPOT = '8488da1a-81c1-4475-8fbf-946ef6ee4652';
  }
  let p = process.env.PORTALID_HUBSPOT;
  let f = process.env.FORMID_HUBSPOT; 
  console.log("process.env.PORTALID_HUBSPOT     -> " + p);
  console.log("process.env.FORMID_HUBSPOT       -> " + f);

  let data = {
    fields: fields,
  };

  var final_data = JSON.stringify(data);
  console.log('data: ', final_data);

  var headers = new Headers();
  headers.append("Content-Type", "application/json");
  await fetch(
    //"https://api.hsforms.com/submissions/v3/integration/submit/45185422/8488da1a-81c1-4475-8fbf-946ef6ee4652",  //DES
    //"https://api.hsforms.com/submissions/v3/integration/submit/5881411/ac707646-bfbd-47db-8c78-0523ce3759eb", //PROD
    `https://api.hsforms.com/submissions/v3/integration/submit/${p}/${f}`,

    {
      body: final_data,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => {
      console.log("Realizando operación ... ", response);
    })
    .catch((e) => {
      console.log(e);
    });

}

const segundoPaso = ({ faqs, pyme }) => {
  const [current_question, setCurrent_question] = useState(0);
  const [productForms, setProductForms] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [otherProducts, setOtherProducts] = useState([]);
  const [tyc, setTyc] = useState({ value: false, warning: "" });
  const [, updateState] = React.useState();
  const [privacidadPosition, setPrivacidadPosition] = useState("origin");
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [modalContent, setModalContent] = useState(null);
  let modal = StepModal();

  useEffect(() => {
    if (modalContent) {
      modal.setShowState(true);
    } else {
      modal.setShowState(false);
    }
  }, [modalContent]);

  const products = cotizacionProductos;
  let otherForms = {};
  let openStatus = {};
  Object.keys(products).forEach((prod) => {
    otherForms[prod] = FormFactory(products[prod].campos);
    openStatus[prod] = { modal: true, form: false };
  });

  let [otherFormsOpened, setOtherFormsOpened] = useState(openStatus);

  const formObject = {
    ready: false,
    campos: [
      {
        type: "text",
        label: {
          class: "label",
          text: "Tu nombre:",
        },
        name: "nombre",
        placeholder: "Nombre (s)",
        requirements: ["null", "size>2", "size<61", "space"],
        format: "texto",
        id: "pyme_nombre",
        outerDivClass: "input-field half",
        innerDivFieldClass: "input-container",
        innerFieldClass: "input-content",
        innerDivWarClass: "warning-container",
        innerWarningClass: "warning-content",
        readyClass: "ready-field",
        activeClass: "active-field",
      },
      {
        type: "text",
        label: {
          class: "label",
          text: "Apellidos:",
        },
        name: "apellido",
        placeholder: "Apellido(s)",
        requirements: ["null", "size>2", "size<61", "space"],
        format: "texto",
        id: "pyme_apellido",
        outerDivClass: "input-field half",
        innerDivFieldClass: "input-container",
        innerFieldClass: "input-content",
        innerDivWarClass: "warning-container",
        innerWarningClass: "warning-content",
        readyClass: "ready-field",
        activeClass: "active-field",
      },
      {
        type: "radio",
        label: {
          class: "label",
          text: `Tipo de Persona:`,
        },
        name: "tipoPersona",
        placeholder: `Tipo de Persona`,
        requirements: ["null", "space"],
        id: "pyme_tipo_persona",
        outerDivClass: "input-field",
        innerDivFieldClass: "input-container radio-option",
        innerFieldClass: "input-content",
        innerDivWarClass: "warning-container",
        innerWarningClass: "warning-content",
        readyClass: "ready-field",
        activeClass: "active-field",
        value: "Persona Moral",
        options: [
          {
            id: "PM",
            name: "PM",
            value: "Persona Moral",
            label: "Persona Moral"
          },
          {
            id: "PFAE",
            name: "PFAE",
            value: "Persona Fisica con Actividad Empresarial",
            label: "Persona Fisica"
          }
        ]
      },
      {
        type: "text",
        label: {
          class: "label",
          text: `Razón social de la empresa:`,
        },
        name: "empresa",
        placeholder: `Razón social`,
        requirements: ["null", "size>6", "size<161", "space"],
        id: "pyme_razon_social",
        outerDivClass: "input-field",
        innerDivFieldClass: "input-container",
        innerFieldClass: "input-content",
        innerDivWarClass: "warning-container",
        innerWarningClass: "warning-content",
        readyClass: "ready-field",
        activeClass: "active-field"
      },
      {
        type: "text",
        label: {
          class: "label",
          text: `Tu número celular:`,
        },
        name: "phone",
        placeholder: "Teléfono celular",
        requirements: ["null", "number", "size=10", "size<11", "ceroFrist"],
        id: "pyme_number",
        outerDivClass: "input-field",
        innerDivFieldClass: "input-container",
        innerFieldClass: "input-content",
        innerDivWarClass: "warning-container",
        innerWarningClass: "warning-content",
        readyClass: "ready-field",
        activeClass: "active-field",
      },
      {
        type: "text",
        label: {
          class: "label",
          text: "Tu correo:",
        },
        name: "correo",
        placeholder: "ejemplo@correo.com",
        requirements: ["null", "email"],
        id: "pyme_email",
        outerDivClass: "input-field",
        innerDivFieldClass: "input-container",
        innerFieldClass: "input-content",
        innerDivWarClass: "warning-container",
        innerWarningClass: "warning-content",
        readyClass: "ready-field",
        activeClass: "active-field",
      },
      {
        type: "text",
        label: {
          class: "label",
          text: `Código de seguridad:`,
        },
        name: "passcode",
        placeholder: "*****",
        requirements: ["null", "size=6", "size<7", "containSapces"],
        id: "pyme_passcode",
        outerDivClass: "input-field",
        innerDivFieldClass: "input-container",
        innerFieldClass: "input-content",
        innerDivWarClass: "warning-container",
        innerWarningClass: "warning-content",
        readyClass: "ready-field",
        activeClass: "active-field",
      },
    ],
  };

  let form = FormFactory(formObject.campos);
  formObject.campos.forEach((campo) => {
    if (typeof campo.size !== "undefined")
      campo.size.forEach((link) => {
        form.getField(campo.name).linkSize(form.getField(link));
      });
  });

  useEffect(() => {
    let productFormsLS = toJS(localStorage.getItem("productForms"));
    let selectedProductsLS = toJS(localStorage.getItem("selectedProducts"));
    let otherProductsLS = toJS(localStorage.getItem("otherProducts"));

    const refererParam = new URLSearchParams(window.location.search).get("referer");
    const refererData = refererListData[refererParam];
    const referer = refererData ? refererParam : "";
    if (!(productFormsLS && selectedProductsLS && otherProductsLS)) {
      //window.location.href = !refererData ? "/compra-en-linea" : `/compra-en-linea?referer=${referer}`;
    } else {
      setProductForms(productFormsLS);
      setSelectedProducts(selectedProductsLS);
      setOtherProducts(otherProductsLS);
      let preloadInfo = localStorage.getItem("infoPymeData");
      if (preloadInfo) {
        Object.keys(preloadInfo).forEach((x) => {
          if (preloadInfo[x] && x == "tyc") {
            setTyc({ value: true, warning: "" });
          }
          if (preloadInfo[x] && x != "tyc") {
            form.getField(x).changeValue(preloadInfo[x]);
          }
        });
      }
    }
    return function () {
    };

  }, []);
  useEffect(() => {
    let origPosition = "origin";
    Object.keys(otherFormsOpened).forEach((key) => {
      if (otherFormsOpened[key].form) origPosition = key;
    });
    setPrivacidadPosition(origPosition);
  }, [otherFormsOpened]);

  useEffect(() => {
    form.getField("tipoPersona").changeValue("Persona Moral");
  }, []);

  let goBackB = () => {
    if (current_question == 0) {
      goBack();
    } else {
      setCurrent_question(current_question - 1);
    }
  };

  let goBack = () => {
    const refererParam = new URLSearchParams(window.location.search).get("referer");
    const refererData = refererListData[refererParam];
    const referer = refererData ? refererParam : "";

    let fieldNames = form.getFields();
    let pymeInfo = {};
    Object.keys(fieldNames).forEach((x) => {
      pymeInfo[x] = form.getField(x).getValue();
      console.log(pymeInfo[x]);
    });
    pymeInfo.tyc = tyc.value;
    localStorage.setItem("infoPymeData", pymeInfo);
    window.location.href = !refererData ? "/compra-en-linea" : `/compra-en-linea?referer=${referer}`;
  };
  let handleTyc = () => {
    setTyc({ value: !tyc.value, warning: "" });
  };

  let showMissing = () => {
    if (!form.isReady()) {
      form.getMissing();
    }
    if (!tyc.value) {
      setTyc({ value: false, warning: "Este campo es requerido" });
    }
    setTimeout(function () {
      ScrollToClass("warning-content", -150);
    }, 200);
  };
  let Privacidad = ({ otherProd = false }) => {
    return (
      <PrivacidadComponent version={otherProd ? "A" : "B"}>
        <div className={`checkbox_input ${!otherProd && "checkbox_input_v2"}`}>
          <label>
            <div className="checkbox_image">
              <input
                type="checkbox"
                name="privacidad"
                checked={tyc.value}
                onChange={handleTyc}
              />
              <img
                className="unchecked"
                alt="sin leer"
                src="/assets/oferta-digital/pyme/box_unchecked.png"
              />
              <img
                className="checked"
                alt="sin leer"
                src="/assets/oferta-digital/pyme/box_checked.png"
              />
            </div>
            <span>
              He leído y acepto el{" "}
              <a href="/assets/AvisoPrivacidad.pdf" target="_blank">
                Aviso de privacidad
              </a>
            </span>
          </label>
          {tyc.warning ? (
            <div className="warning-container">
              <span className="warning-content">{tyc.warning}</span>
            </div>
          ) : null}
        </div>
        <BotonOD
          onClick={
            tyc.value && areTheyReady(questionFields[current_question])
              ? async () => {
                modal.setShowState(true);
                setModalContent(

                  <div className="popup-container" style={{ backgroundColor: '#fff', width: '928px', height: '600px', borderRadius: '20px', padding: '48px 64px', top: '208px', position: 'absolut', textAlign: 'center', margin: 'auto'}}>
                    <div className="shared-popup-content" >
                      <div className="compartir__cotizacion__popup">
                        <div className="header">
                          <div>
                            <div className="title">
                              ¡Muchas gracias por tu interés en nuestras soluciones!
                            </div>
                            <img
                              src="/assets/infoPyme/IMG.jpg"
                            />

                            <p>
                              Hemos recibido tu información. En breve, uno de nuestros expertos se comunicará contigo para <b>atender tus necesidades y ofrecerte la mejor solución.</b>
                            </p>
                          </div>
                        </div>

                        <button className="shared__quotation__button" type="submit" style={{borderRadius: '22.8px', background: 'linear-gradient(134.55deg, #FCC37C -21.57%, #FF8F00 102.1%)' , fontFamily: 'Source Sans Pro', fontWeight: '600', padding: '13px 40px', border: 'none', color: 'white', cursor: 'pointer' }}
                          onClick={() => {
                            let selectedProductsLS = toJS(localStorage.getItem("selectedProducts"));
                            let productFormsLS = toJS(localStorage.getItem("productForms"));

                            let productosCompletos = [];
                            let fnCreaListoProductos = (selectedProductsLS) => {

                              for (let i = 0; i < selectedProductsLS.length; i++) {
                                switch (selectedProductsLS[i]) {
                                  case 'combustible':
                                    productosCompletos.push("Vales de combustible");
                                    selectedProductsLS.shift();
                                    break;
                                  case 'despensa':
                                    productosCompletos.push("Vales de despensa");
                                    selectedProductsLS.shift();
                                    break;
                                  case 'incentivos':
                                    productosCompletos.push("Incentivos para empleados");
                                    selectedProductsLS.shift();
                                    break;
                                }
                              };
                              return productosCompletos
                            }
                            fnCreaListoProductos(selectedProductsLS);

                            var dataSpecial =
                            {
                              "firstname": form.getField("nombre").getValue(),
                              "lastname": form.getField("apellido").getValue(),
                              "email": form.getField("correo").getValue(),
                              "phone": form.getField("phone").getValue(),
                              "razon_social_de_la_empresa": form.getField("empresa").getValue(),
                              "producto_obd": productosCompletos.join(';') + ';',
                              "monto_mensual_incentivos_para_empleados_obd": productFormsLS.incentivos.values.presupuesto == {} || "" ? "0" : productFormsLS.incentivos.values.presupuesto,
                              "monto_mensual_vales_de_despensa_obd": productFormsLS.despensa.values.presupuesto == {} || "" ? "0" : productFormsLS.despensa.values.presupuesto,
                              "monto_mensual_vales_de_combustible_obd": productFormsLS.combustible.values.presupuesto == {} || "" ? "0" : productFormsLS.combustible.values.presupuesto,
                              "numero_de_tarjetas_despensa": productFormsLS.despensa.values.numero_tarjetas == {} || "" ? "0" : productFormsLS.despensa.values.numero_tarjetas,
                              "numero_de_tarjetas_combustible": productFormsLS.combustible.values.numero_tarjetas == {} || "" ? "0" : productFormsLS.combustible.values.numero_tarjetas,
                              "numero_de_tarjetas_incentivos_para_empleados": productFormsLS.incentivos.values.numero_tarjetas == {} || "" ? "0" : productFormsLS.incentivos.values.numero_tarjetas,
                              "id_oportunidad_obd": "0",
                              "link_obd": "",
                              "inversion_inicial_obd": "0",
                              "inscripcion_obd": "0",
                              "costo_de_envio": "0",
                              "total_tarjetas_obd": "0",
                              "total_tarjetas_despensa": "0",
                              "total_tarjetas_combustible": "0",
                              "total_tarjetas_incentivos_obd": "0",
                              "costo_mensual_despensa": productFormsLS.despensa.values.presupuesto == {} || "" ? "0" : productFormsLS.despensa.values.presupuesto,
                              "costo_mensual_combustible": productFormsLS.combustible.values.presupuesto == {} || "" ? "0" : productFormsLS.combustible.values.presupuesto,
                              "costo_mensual_incentivos_obd": productFormsLS.incentivos.values.presupuesto == {} || "" ? "0" : productFormsLS.incentivos.values.presupuesto,
                              "costo_por_servicio_de_dispersion_despensa_obd": "",
                              "tasa_despensa_obd": "",
                              "costo_por_servicio_de_dispersion_combustible": "",
                              "tasa_combustible_obd": "",
                              "costo_por_servicio_de_dispersion_incentivos_obd": "",
                              "tasa_incentivos_obd": "",
                              "referencia_obd": "",
                              "url_cotizacion_obd": ""
                            };

                            console.log("Llamando a HubSpot");
                            callHubSpot2(dataSpecial);
                            setModalContent(false);
                            window.location.href = '/compra-en-linea/';
                          }}
                        >
                          Entendido
                        </button>
                      </div>
                    </div>
                  </div>


                )
              }
              : () => {
                checkFields(questionFields[current_question]);
                if (!tyc.value) {
                  setTyc({
                    value: false,
                    warning: "Este campo es requerido",
                  });
                }
              }
          }
          disabled={
            !areTheyReady(questionFields[current_question]) || !tyc.value
          }
        >
          {pyme.step4Cta}
        </BotonOD>
      </PrivacidadComponent>
    );
  };

  const advanceQuestion = () => {
    setCurrent_question(current_question + 1);
  };

  const getBannerSrc = () => {
    if (
      selectedProducts.includes("despensa") &&
      selectedProducts.includes("combustible") &&
      selectedProducts.includes("incentivos")
    ) {
      return pyme.bannerCombustibleDespensaIncentivos;
    }
    if (
      selectedProducts.includes("despensa") &&
      selectedProducts.includes("combustible")
    ) {
      return pyme.bannerCombustibleDespensa;
    }
    if (
      selectedProducts.includes("combustible") &&
      selectedProducts.includes("incentivos")
    ) {
      return pyme.bannerCombustibleIncentivos;
    }
    if (
      selectedProducts.includes("despensa") &&
      selectedProducts.includes("incentivos")
    ) {
      return pyme.bannerDespensaIncentivos;
    }
    if (selectedProducts.includes("combustible")) {
      return pyme.bannerCombustible;
    }
    if (selectedProducts.includes("despensa")) {
      return pyme.bannerDespensa;
    }
    if (selectedProducts.includes("incentivos")) {
      return pyme.bannerIncentivos;
    }
    return {
      url: "",
      alt: "",
    };
  };

  const getBannerMobileSrc = () => {
    if (
      selectedProducts.includes("despensa") &&
      selectedProducts.includes("combustible") &&
      selectedProducts.includes("incentivos")
    ) {
      return pyme.bannerCombustibleDespensaIncentivosMobile;
    }
    if (
      selectedProducts.includes("despensa") &&
      selectedProducts.includes("combustible")
    ) {
      return pyme.bannerCombustibleDespensaMobile;
    }
    if (
      selectedProducts.includes("combustible") &&
      selectedProducts.includes("incentivos")
    ) {
      return pyme.bannerCombustibleIncentivosMobile;
    }
    if (
      selectedProducts.includes("despensa") &&
      selectedProducts.includes("incentivos")
    ) {
      return pyme.bannerDespensaIncentivosMobile;
    }
    if (selectedProducts.includes("combustible")) {
      return pyme.bannerCombustibleMobile;
    }
    if (selectedProducts.includes("despensa")) {
      return pyme.bannerDespensaMobile;
    }
    if (selectedProducts.includes("incentivos")) {
      return pyme.bannerIncentivosMobile;
    }
    return {
      url: "",
      alt: "",
    };
  };

  const pv2_copies = [
    {
      title: pyme.step1Title,
      subtitle: pyme.step1Subtitle,
    },
    {
      title: pyme.step2Title,
      subtitle: pyme.step2Subtitle,
    },
    {
      title: pyme.step3Title,
      subtitle: pyme.step3Subtitle,
    },
    {
      title: pyme.step4Title,
      subtitle: pyme.step4Subtitle,
    },
    {
      title: pyme.step5Title,
      subtitle: pyme.step5Subtitle,
    },
  ];

  const areTheyReady = (questions) => {
    let ready = true;
    questions.forEach((q) => {
      if (!q.isReady()) ready = false;

    });
    return ready;
  };

  const checkFields = (questions) => {
    questions.forEach((x) => x.checkField(true));
  };
  const questionFields = {
    0: [Object.values(form.getFields())[0], Object.values(form.getFields())[1]],
    1: [Object.values(form.getFields())[2], Object.values(form.getFields())[3]],
    2: [Object.values(form.getFields())[4]],
    3: [Object.values(form.getFields())[5]],
    4: [Object.values(form.getFields())[6]],
  };

  const router = useRouter();

  const refererParam = router.query.referer;
  const refererData = refererListData[refererParam];
  const referer = refererData ? refererParam : "";

  const cancelSpace = (idElement) => {
    document.getElementById(idElement)
      .addEventListener("keydown", ($event) => {
        if ($event.code === 'Space') {
          $event.preventDefault();
        }
      })
  }

  const isCeroFirstItem = (idElement) => {
    let numberInput = document.getElementById(idElement);
    numberInput.addEventListener("keydown", ($event) => {
      let { value } = numberInput;
      if ("0" === $event.key && value === "") {
        $event.preventDefault();
      }
      if ("0" === $event.key && value.length > 0) {
        $event.preventDefault();
        $event.target.value = ``;
        $event.target.value = `${value}${$event.key}`;
      }
    })
  }

  const cancelInitialSpace = (idElement) => {
    let input = document.getElementById(idElement);
    input.addEventListener("keydown", ($event) => {
      let { value } = input;
      if ($event.code === 'Space' && value === '') {
        $event.preventDefault();
      }
      if (value.length > 0) {
        let lastCharacter = [...value].pop();
        if (lastCharacter === ' ' && $event.code === 'Space') {
          $event.preventDefault();
          $event.target.value = ``;
          $event.target.value = `${value.trim()} `;
        }
        if ($event.code === 'Space' && lastCharacter !== ' ') {
          $event.preventDefault();
          $event.target.value = `${value.trim()} `;
        }
      }
    });
  }

  const replaceMoreSpaces = (idElement) => {
    document.getElementById(idElement).addEventListener("paste", ($event) => {
      let paste = $event.clipboardData.getData('text').trim();
      if (paste !== '') {
        $event.preventDefault();
        $event.target.value = paste.replace(/\s\s+/g, ' ');
      } else {
        $event.preventDefault();
      }
    })
  }

  const cancelDrop = (idElement) => {
    document.getElementById(idElement).addEventListener("drop", ($event) => {
      $event.preventDefault();
    })
  };

  const validationsFormName = () => {
    cancelInitialSpace("pyme_nombre");
    cancelInitialSpace("pyme_apellido");
    cancelDrop("pyme_nombre");
    cancelDrop("pyme_apellido");
    replaceMoreSpaces("pyme_nombre");
    replaceMoreSpaces("pyme_apellido");
  }

  const validationsForBusinessName = () => {
    cancelInitialSpace("pyme_razon_social");
    replaceMoreSpaces("pyme_razon_social");
  }

  useEffect(() => {
    switch (current_question) {
      case 0:
        setTimeout(() => {
          validationsFormName();
        }, 500);
        break;
      case 1:
        validationsForBusinessName();
        break;
      case 2:
        isCeroFirstItem("pyme_number");
      case 3:
        cancelSpace("pyme_passcode")
        break;
    }
  }, [current_question])

  return (
    <InfoClienteContainer>
      {modal.modal(modalContent)}

      <PymeB>
        <a className="atras_btn" onClick={goBackB}>
          <img src="/assets/oferta-digital/pyme/back.svg" />
        </a>
        <div className="pv2__banner">
          <img
            className="desktop-img"
            src={getBannerSrc().url}
            alt={getBannerSrc().alt}
          />
          <img
            className="mobile-img"
            src={getBannerMobileSrc().url}
            alt={getBannerMobileSrc().alt}
          />
        </div>
        <div className="pv2__form">
          <div className="counter desktop">
            Paso <strong>{current_question + 1}</strong> de 4
          </div>
          {Object.values(questionFields).map((fields, i) => (
            <div
              key={i}
              className={`pv2__form__item ${i == current_question
                ? "current"
                : i < current_question
                  ? "prev_question"
                  : "next_question"
                }`}
            >
              <div
                className="pv2__form__title"
                dangerouslySetInnerHTML={{
                  __html: `${i == 1
                    ? pv2_copies[i].title.includes("${name}")
                      ? pv2_copies[i].title.replace(
                        "${name}",
                        form.getField("nombre").getValue().split(" ")[0]
                      )
                      : pv2_copies[i].title
                    : pv2_copies[i].title
                    }`,
                }}
              />
              {pv2_copies[i].subtitle ? (
                <div className="pv2__form__subtitle">
                  {pv2_copies[i].subtitle}
                </div>
              ) : null}
              <div>{fields.map((x) => x.getHTML())}</div>
              <div className="counter mobile">
                Paso <strong>{current_question + 1}</strong> de 4
              </div>
            </div>
          ))}
          <div className="pv2__form__footer">
            {current_question == 0 && (
              <BotonOD
                disabled={!areTheyReady(questionFields[current_question])}
                onClick={
                  areTheyReady(questionFields[current_question])
                    ? advanceQuestion
                    : () => {
                      checkFields(questionFields[current_question]);
                    }
                }
              >
                {pyme.step1Cta}
              </BotonOD>
            )}
            {current_question == 1 && (
              <BotonOD
                disabled={!areTheyReady(questionFields[current_question])}
                onClick={
                  areTheyReady(questionFields[current_question])
                    ? advanceQuestion
                    : () => {
                      checkFields(questionFields[current_question]);
                    }
                }
              >
                {pyme.step2Cta}
              </BotonOD>
            )}
            {current_question == 2 && (
              <BotonOD
                disabled={!areTheyReady(questionFields[current_question])}
                onClick={
                  areTheyReady(questionFields[current_question])
                    ? advanceQuestion
                    : () => {
                      checkFields(questionFields[current_question]);
                    }
                }
              >
                {pyme.step3Cta}
              </BotonOD>
            )}
            {current_question == 3 && <Privacidad />}

          </div>
        </div>
      </PymeB>

      <Datos_Protegidos>
        <div className="title">TUS DATOS ESTAN PROTEGIDOS CON NOSOTROS</div>
        <div className="logo-container">
          <img
            className="amvo"
            src="/assets/oferta-digital/pyme/afiliado-amvo-color.svg"
          />
          <img
            className="sige"
            src="/assets/oferta-digital/pyme/LOGO_ISO_27001_SIGE_1.svg"
          />
          <img
            className="inai"
            src="/assets/oferta-digital/pyme/Logotipo_REA_INAI_Vector-06_certificado_1.svg"
          />
        </div>
      </Datos_Protegidos>
      <FAQ faqs={faqs} />
    </InfoClienteContainer>
  );
};
export default segundoPaso;
